import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/axiosConfig';
import PageLoadingArea from '../../components/PageLoader/PageLoadingArea';
import usePageLoading from '../../hooks/usePageLoading';
import '../../styles/FormPage.css';

function CreateVendorType() {
    const { vendorTypeId } = useParams();
    const navigate = useNavigate();
    const { isLoading, withLoading } = usePageLoading(Boolean(vendorTypeId));
    const [formData, setFormData] = useState({
        type: ''
    });

    useEffect(() => {
        if (vendorTypeId) {
            withLoading(async () => {
                const res = await api.get(`/vendor-types/${vendorTypeId}`);
                setFormData({
                    type: res.data.type || ''
                });
            }).catch(() => {
                alert('Error fetching vendor type data');
            });
        }
    }, [vendorTypeId, withLoading]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            type: formData.type.trim()
        };

        const apiCall = vendorTypeId
            ? api.put(`/vendor-types/${vendorTypeId}`, payload)
            : api.post('/vendor-types', payload);

        apiCall
            .then(() => {
                navigate('/admin/vendor-types');
            })
            .catch((error) => {
                const message = error.response?.data?.Error || 'Error saving vendor type';
                alert(message);
            });
    };

    return (
        <PageLoadingArea isLoading={isLoading}>
            <div className="form-page">
                <div className="form-page-header">
                    <div>
                        <h1>{vendorTypeId ? 'Edit vendor type' : 'Add vendor type'}</h1>
                        <p className="form-page-subtitle">
                            {vendorTypeId
                                ? 'Update the vendor type name'
                                : 'Enter a vendor type to use when adding vendors'}
                        </p>
                    </div>
                    <div className="form-page-actions">
                        <button
                            type="button"
                            className="form-page-btn-secondary"
                            onClick={() => navigate('/admin/vendor-types')}
                        >
                            Back to list
                        </button>
                        <button
                            type="submit"
                            form="create-vendor-type-form"
                            className="form-page-btn"
                        >
                            {vendorTypeId ? 'Update type' : 'Save type'}
                        </button>
                    </div>
                </div>

                <section className="form-page-section">
                    <div className="form-page-section-head">
                        <div>
                            <h2>Vendor type details</h2>
                            <p className="form-page-section-hint">Type name used in vendor records</p>
                        </div>
                    </div>

                    <form id="create-vendor-type-form" onSubmit={handleSubmit}>
                        <div className="form-page-grid cols-3">
                            <div className="form-page-field span-full">
                                <label htmlFor="type">Type</label>
                                <input
                                    type="text"
                                    id="type"
                                    name="type"
                                    value={formData.type}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter vendor type"
                                />
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </PageLoadingArea>
    );
}

export default CreateVendorType;
